export default __webpack_public_path__ + "static/mira-mezini-a56046ae07f864d0aa6dacf87392bb38.jpg";